import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild, HostListener  } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-create-shipping-label',
  templateUrl: './create-shipping-label.component.html',
  styleUrls: ['./create-shipping-label.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class CreateShippingLabelComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');
    
    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(250),
      distinctUntilChanged())
      .subscribe(value => {
       this.Filter.SearchTerm = value;
       
       if(this.Right != null){
        this.Right.ContactCompany = value;
       }

       if(this.Filter.SearchTerm.length == 0){
        this.Partners = [];
        this.PartnersCount = 0;
       }
       else if((this.CurrentPartner?.ID?.length > 0) == false){
        this.GetPartnersFiltered();
       }
      });

      // Debounce search.
    this.countryTermUpdate.pipe(
      debounceTime(100),
      distinctUntilChanged())
      .subscribe(value => {
        this.filterCountriesBySearchTerm(value);
      });

      // Debounce search.
    this.countryTermUpdate2.pipe(
      debounceTime(100),
      distinctUntilChanged())
      .subscribe(value => {
        this.filterCountries2BySearchTerm(value);
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  countryTermUpdate = new Subject<string>();
  countryTermUpdate2 = new Subject<string>();
  loadingShipment:boolean;
  SearchTerm:string;

  ShippingResponsabilities:any[];
  ShippingServiceTypes:any[];
  ShippingWays:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  Directions:any[];
  ShowDeleteBoxQuestion:boolean;
  CurrentBox:any;

  Partners:any[];
  PartnersCount:number;

  TrackEvents:any[];
  CurrentTracking:any;
  ShippingServiceType:any;
  ShippingDetails: {[k: string]: any} = {};
  CreateShippingLabelSettings: {[k: string]: any} = {};
  DownloadTypes:any[];
  Countries:any[];
  FilteredCountries:any[];
  FilteredCountries2:any[];

  Left: {[k: string]: any} = {};
  LeftOriginal: {[k: string]: any} = {};
  LeftChanged:boolean;
  
  Right: {[k: string]: any} = {};
  RightOriginal: {[k: string]: any} = {};
  RightChanged:boolean;

  Filter: {[k: string]: any} = {};
  ShippingAddresses:any[];
  ShippingMasterData: {[k: string]: any} = {};
  NewPartnerAddress: {[k: string]: any} = {};
  Copy:string;
  Direction:number;

  shipment:number;
  showBottom:boolean = false;
  TaskCompleted:boolean = false;
  HistoryPlaceHolder:string;

  // Document Connection Pre-check
  ShowDocumentPrecheck:boolean = false;
  UnlinkedDocuments:any[] = [];
  SelectedUnlinkedDocument:any = null;
  PendingWithPickup:boolean = false;

  ngOnInit(): void {
    this.InitializeFilter();
    this.InitializeHistoryPlaceholder();
  }

  getParamValues() {

    var copy = "false";
    var direction = 0;

    this.route.queryParams.subscribe(params => {   

      if(params['copy']){
        copy = params['copy'];
        this.Copy = copy;
      }
        
      if(params['shipment']){
        this.shipment = parseInt(params['shipment']);
      }

      if(params['direction']){
        direction = parseInt(params['direction']);
        this.Direction = direction;
      }
    });
  }

  GetShippingDetails(ID:number, DirectionID:number, copy:boolean, ErasePriceTrackingData:boolean){
    
    var Direction = this.Directions?.filter(x => x.ID == DirectionID)[0];
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetailsID:ID,
      ShippingMasterData:this.ShippingMasterData,
      ShippingDirection:Direction,
      ErasePriceTrackingData:ErasePriceTrackingData
    };

    this.loadingShipment = true;

    this.managementService.GetShippingDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        if(copy == true){
          this.ShippingDetails = response["ShippingDetails"];

          if(this.ShippingDetails.ShippingDirection.ID == 1){
          
            this.LeftOriginal = JSON.parse(JSON.stringify(this.ShippingDetails.Sender));
            this.Left = this.ShippingDetails.Sender;
  
            this.RightOriginal = JSON.parse(JSON.stringify(this.ShippingDetails.Receiver));
            this.Right = this.ShippingDetails.Receiver;
            this.Filter.SearchTerm = this.Right?.ContactCompany;
         } 
         else if(this.ShippingDetails.ShippingDirection.ID == -1){
          
            this.LeftOriginal = JSON.parse(JSON.stringify(this.ShippingDetails.Receiver));
            this.Left = this.ShippingDetails.Receiver;
  
            this.RightOriginal = JSON.parse(JSON.stringify(this.ShippingDetails.Sender));
            this.Right = this.ShippingDetails.Sender;
            this.Filter.SearchTerm = this.Right.ContactCompany;
         } 
        }

        this.ShippingCompanies.forEach(element => {
          if (element.ID === this.ShippingDetails.ShippingCompany.ID) {
            element.IsSelected = true;
          } else {
            element.IsSelected = false;
          }
        });

        this.SelectShippingServiceType(this.ShippingDetails.ShippingServiceType);
        this.GetPartner(this.Right.ParentPartnerID);
        this.showBottom = true;
      }
   
      this.loadingShipment = false;
    });
  }

  GetPartner(id:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:id,
      WithAllData:true
    };

    this.parent.loading = true;

    this.service.GetPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.CurrentPartner = response["Partner"];

       if(this.Copy != "true"){
        this.InitializeSenderReceiver();
       }
      }
   
      this.parent.loading = false;
    });
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;
    
    this.Filter.Country = {};
    this.Filter.Country = null;

    this.ShippingDetails.Boxes = [];
    this.ShippingDetails.ShippingCompany = {};
    this.ShippingDetails.ShippingAddress = {};
    this.ShippingDetails.ShippingDirection = {};
    this.getParamValues();
    this.GetShippingMasterData();
  }

  loadingCountry:boolean;

  InitializeSearch(){
      if(this.Filter.SearchTerm?.length > 2){
        this.CurrentPartner = {};
        this.Right = null;
        this.RightOriginal = null;
        this.GetPartnersFiltered();
      }
  }

  DeselectCountry(){
    this.Right.Country = [];
    this.updateRightChanged();
  }
  
  DeselectNewAddressCountry(){
    this.NewPartnerAddress.Country = [];
    this.ProofNewPartnerAddress();
  }
   
  DeselectNewCompanyAddressCountry(){
    this.Left.Country = [];
  }

  InitializeCountrySearch(){

      if((this.Right?.Country?.ID > 0) == false){
        this.Right.Country = {};
        this.FilteredCountries = this.Countries.slice(0, 10);
      }
  }

  InitializeNewAddressCountrySearch(){

    if((this.NewPartnerAddress?.Country?.ID > 0) == false){
      this.NewPartnerAddress.Country = {};
      this.FilteredCountries = this.Countries.slice(0, 10);
    }
}

InitializeNewCompanyAddressCountrySearch(){

  if((this.Left?.Country?.ID > 0) == false){
    this.Left.Country = {};
    this.FilteredCountries2 = this.Countries.slice(0, 10);
  }
}

filterCountries2BySearchTerm(searchTerm: string): void {

  this.loadingCountry = true;

  this.FilteredCountries2 = this.Countries.filter(country => 
      country.Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  this.loadingCountry = false;
}

  filterCountriesBySearchTerm(searchTerm: string): void {

    this.loadingCountry = true;

    this.FilteredCountries = this.Countries.filter(country => 
        country.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    this.loadingCountry = false;
  }

  SelectCountry(c:any){
    this.Right.Country = JSON.parse(JSON.stringify(c));
    this.FilteredCountries = [];
    this.FilteredCountries2 = [];
  }
  
  SelectNewPartnerAddressCountry(c:any){
    this.NewPartnerAddress.Country = JSON.parse(JSON.stringify(c));
    this.FilteredCountries = [];
    this.ProofNewPartnerAddress();
  }

  SelectNewCompanyAddressCountry(c:any){
    this.Left.Country = JSON.parse(JSON.stringify(c));
    this.FilteredCountries2 = [];
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.Filter.SearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.loadingShipment = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }
   
      this.loadingShipment = false;
    });
  }

  GeneralShippingServiceTypes:any[];

  GetShippingMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetShippingMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.ShippingMasterData = JSON.parse(JSON.stringify(response));
     this.ShippingResponsabilities = response["ShippingResponsabilities"];
     // Filter out ShippingServiceType with ID == 2
     this.GeneralShippingServiceTypes = response["ShippingServiceTypes"]?.filter(x => x.ID != 2) || [];
     this.ShippingServiceTypes = response["ShippingServiceTypes"]?.filter(x => x.ID != 2) || [];
     this.ShippingWays = response["ShippingWays"];
     this.ShippingCompanies = response["APIShippingCompanies"];
     this.WeightTypes = response["WeightTypes"];
     this.Directions = response["Directions"];

     this.ShippingDetails.ShippingDirection = this.Directions[0];
     this.ShippingDetails.WeightType = this.WeightTypes[0];
     this.ShippingDetails.ShippingWay = this.ShippingWays[0];

     if(this.Copy != "true"){
      this.SelectShippingCompany(this.ShippingCompanies[1]);
      this.InitializeSenderReceiver();
     }
     else if(this.Copy == "true" && this.shipment > 0 && this.Direction != 0){
      this.GetShippingDetails(this.shipment, this.Direction, true, true);
     }
   
     this.DownloadTypes = response["DownloadTypes"];
     this.CreateShippingLabelSettings.DownloadType = this.DownloadTypes[0];
     this.CreateShippingLabelSettings.SendEmail = false;
     this.Countries = this.parent.masterData.Countries;
     this.PatchFlagURLs(this.Countries);
    }
 
    this.parent.loading = false;
   });
   }

   SelectShippingCompany(s:any){
    this.ShippingCompanies.forEach(element => {
      if (element.ID === s.ID) {
        element.IsSelected = true;
      } else {
        element.IsSelected = false;
      }
    });

    this.ShippingDetails.ShippingCompany = s;

    // Reset manual selection when carrier changes
    this.ManualCarrierAccountSelection = false;

    if(this.ShippingDetails.ShippingCompany.ShippingServiceTypes != null && this.ShippingDetails.ShippingCompany.ShippingServiceTypes.some(x => x.IsSelected == true)){
        this.SelectShippingServiceType(this.ShippingDetails.ShippingCompany.ShippingServiceTypes.filter(x => x.IsSelected == true)[0]);
    } else {
        // Run algorithm if no service type selection triggers it
        this.RunCarrierAccountSelectionAlgorithm();
    }
   }

   GetShippingCompanyServiceTypes(CompanyID:number){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     CompanyID:CompanyID,
     PartnerID:this.CurrentPartner?.ID,
     DirectionID:this.ShippingDetails.ShippingDirection?.ID
   };
 
  this.parent.loading = true;
 
  this.managementService.GetShippingCompanyServiceTypes(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      // Filter out ShippingServiceType with ID == 2
      this.ShippingDetails.ShippingCompany.ShippingServiceTypes = response["ShippingServiceTypes"]?.filter(x => x.ID != 2) || [];
      this.ShippingDetails.ShippingServiceType = this.ShippingDetails.ShippingCompany.ShippingServiceTypes.filter(x => x.IsSelected == true)[0];
    }
 
    this.parent.loading = false;
    });
  }

  GetCountryShippingOptions(Country:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Country:Country,
      PartnerID:this.CurrentPartner?.ID,
      DirectionID:this.ShippingDetails.ShippingDirection?.ID,
      ShippingCompany:this.ShippingCompanies.filter(x => x.IsSelected == true)[0]
    };
  
   this.parent.loading = true;
  
   this.managementService.GetCountryShippingOptions(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.ShippingCompanies = response["ShippingCompanies"];

       if(this.ShippingCompanies.some(x => x.IsSelected == true)){
          this.SelectShippingCompany(this.ShippingCompanies.filter(x => x.IsSelected == true)[0]);
       }
       else if(this.ShippingCompanies != null && this.ShippingCompanies.length > 0){
        this.SelectShippingCompany(this.ShippingCompanies[0]);
       }
     }
  
     this.parent.loading = false;
     });
  }

  SelectShippingServiceType(s:any){
    if(s != null){
      this.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(s));
      this.ShippingDetails.ShippingServiceType.IsSelected = true;

      this.ShippingDetails.ShippingCompany.ShippingServiceTypes.forEach(element => {
        element.IsSelected = false;
      });

      this.ShippingDetails.ShippingCompany.ShippingServiceTypes.filter(x => x.ID == this.ShippingDetails.ShippingServiceType.ID)[0].IsSelected = true;

      // Re-run carrier account selection when service type changes (unless manually selected)
      this.RunCarrierAccountSelectionAlgorithm();
    }
    else{
      this.ShippingDetails.ShippingCompany.ShippingServiceTypes = [];
    }
  }

   TrackShippingLabel(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingCompany:this.ShippingDetails.ShippingCompany,
     TrackingNumber:this.SearchTerm
   };
 
  this.loadingShipment = true;
 
  this.managementService.TrackShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     this.ShowPrintButton = false;
    }
    else if(response["Status"] == 1){
      this.TrackEvents = response["Events"];
      this.Trackings = [];
      this.ShowPrintButton = true;
    }
 
    this.loadingShipment = false;
   });
   }

   PrintShippingLabel(TrackingLabel:string){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingCompany:this.ShippingDetails.ShippingCompany,
     TrackingNumber:TrackingLabel
   };
 
  this.loadingShipment = true;
 
  this.managementService.PrintShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     
    }
 
    this.loadingShipment = false;
   });
   }

   Trackings:any[];
   ShowPrintButton:boolean = false;

   SearchTracking(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     SearchTerm:this.SearchTerm
   };
 
  this.loadingShipment = true;
 
  this.managementService.SearchTracking(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Trackings = response["Trackings"];
      this.CurrentTracking = {};
      this.TrackEvents = [];
      this.ShowPrintButton = false;
    }
 
    this.loadingShipment = false;
   });
   }

   SelectTracking(tracking:any){
    this.CurrentTracking = JSON.parse(JSON.stringify(tracking));
    this.SearchTerm = JSON.parse(JSON.stringify(tracking?.Box?.TrackingLabel));
    this.SelectShippingCompany(JSON.parse(JSON.stringify(tracking.ShippingCompany)));
    this.Trackings = [];
    this.TrackShippingLabel();
   }

   SwitchDirection(){
    if(this.ShippingDetails.ShippingDirection.ID == -1){
      this.ShippingDetails.ShippingDirection = this.Directions.filter(x => x.ID == 1)[0];
    }
    else{
      this.ShippingDetails.ShippingDirection = this.Directions.filter(x => x.ID == -1)[0];
    }

    if(this.SMTPEmails != null){
      this.SMTPEmails.length = 0;
    }

    if(this.CreateShippingLabelSettings != null){
      this.CreateShippingLabelSettings.SendEmail = false;
    }
   }

   CurrentPartner:any;

   SelectPartner(p:any){
    this.CurrentPartner = JSON.parse(JSON.stringify(p));
    this.Filter.SearchTerm = this.CurrentPartner.Name;
    this.Partners = [];
    this.SelectPartnerForNewShipment();
    
    if(this.SMTPEmails == null){
      this.SMTPEmails = [];
    }

    this.SMTPEmails.length = 0;
    this.CreateShippingLabelSettings.SendEmail = false;
  }

  DeselectPartner(){
    this.Filter.SearchTerm = "";
    this.CurrentPartner = {};
    this.Right = null;
    this.RightOriginal = null;
    this.showBottom = false;
    this.searchTermUpdate.next("");
  }

  SelectPartnerForNewShipment(){
    var request = {
      Partner:this.CurrentPartner,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.loadingShipment = true;

    this.managementService.SelectPartnerForNewShipment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.CurrentPartner = response["Partner"];
       this.ShippingDetails.Partner = JSON.parse(JSON.stringify(this.CurrentPartner));

       if((this.ShippingDetails?.Boxes?.length > 0) != true){
          this.AddNewBox(null);
       }

       this.ShippingAddresses = this.CurrentPartner.ShippingAddresses;
       this.InitializeSenderReceiver();
       this.showBottom = true;

       // Reset manual selection flag when partner changes and run algorithm
       this.ManualCarrierAccountSelection = false;
       this.RunCarrierAccountSelectionAlgorithm();
      }
   
      this.loadingShipment = false;
    });
  }

  InitializeSenderReceiver(){

    if(this.ShippingDetails != null && this.ShippingDetails?.Partner != null && this.CurrentPartner?.ID != null){
      this.ShippingDetails.Partner = JSON.parse(JSON.stringify(this.CurrentPartner));
    }

    var request = {
      Partner:this.CurrentPartner,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDirection:this.ShippingDetails.ShippingDirection
    };

    this.loadingShipment = true;

    this.managementService.InitializeSenderReceiver(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
      
       if(this.ShippingDetails.ShippingDirection.ID == 1){
          
          this.LeftOriginal = JSON.parse(JSON.stringify(response["Sender"]));
          this.Left = response["Sender"];

          this.RightOriginal = JSON.parse(JSON.stringify(response["Receiver"]));
          this.Right = response["Receiver"];
       }
       else if(this.ShippingDetails.ShippingDirection.ID == -1){

          this.LeftOriginal = JSON.parse(JSON.stringify(response["Receiver"]));
          this.Left = response["Receiver"];

          this.RightOriginal = JSON.parse(JSON.stringify(response["Sender"]));
          this.Right = response["Sender"];
       }

       // Patch flag URLs on sender/receiver countries
       if(this.Left?.Country) this.PatchFlagURL(this.Left.Country);
       if(this.Right?.Country) this.PatchFlagURL(this.Right.Country);
      }

      if(this.Right != null && this.Right?.Country != null && this.Copy != "true"){
        this.GetCountryShippingOptions(this.Right.Country);
      }
   
      if(this.Filter != null && this.Right != null && this.Right?.ContactCompany?.length > 0){
        this.Filter.SearchTerm = JSON.parse(JSON.stringify(this.Right?.ContactCompany));
      }

      this.GenerateMainAddressLine();
      this.updateRightChanged();

      // ✅ ALWAYS load company shipping addresses and override the company (Left) side
      // This overrides whatever billing address the backend returns with the actual shipping addresses
      this.GetCompanyShippingAddresses();

      this.loadingShipment = false;
    });
  }

  SelectShippingDirection(d:any){
    this.ShippingDetails.ShippingDirection = JSON.parse(JSON.stringify(d));
    // Re-run carrier account selection when direction changes (unless manually selected)
    this.RunCarrierAccountSelectionAlgorithm();
  }

  // Track if user has manually selected a carrier account
  ManualCarrierAccountSelection: boolean = false;
  showCarrierAccountDropdown: boolean = false;

  /**
   * 4-Tier Carrier Account Selection Algorithm
   * Priority 1: Exact Match - ShippingCompanyID + DirectionID + ServiceTypeID all match
   * Priority 2: Partial Match (Service) - ShippingCompanyID + ServiceTypeID match
   * Priority 3: Partial Match (Direction) - ShippingCompanyID + DirectionID match
   * Priority 4: Entity Fallback - First available account for this ShippingCompanyID
   */
  RunCarrierAccountSelectionAlgorithm() {
    // Skip if user has manually selected an account
    if (this.ManualCarrierAccountSelection) {
      return;
    }

    const accounts = this.CurrentPartner?.ContractualConditions?.ShippingCompanyAccounts;
    if (!accounts || accounts.length === 0) {
      return;
    }

    const currentCarrierId = this.ShippingDetails?.ShippingCompany?.ID;
    const currentDirectionId = this.ShippingDetails?.ShippingDirection?.ID;
    const currentServiceTypeId = this.ShippingDetails?.ShippingServiceType?.ID;
    const currentCompanyId = this.parent?.Company?.ID;

    // Filter accounts for the current carrier AND current company
    // Include accounts where FKCompanyID matches OR FKCompanyID is null (partner-specific without company binding)
    const carrierAccounts = accounts.filter(a =>
      a.FKShippingCompanyID === currentCarrierId &&
      (a.FKCompanyID === currentCompanyId || !a.FKCompanyID)
    );
    if (carrierAccounts.length === 0) {
      // Clear selection if no accounts for this carrier/company
      accounts.forEach(a => a.IsSelected = false);
      return;
    }

    // Clear all selections first
    accounts.forEach(a => a.IsSelected = false);

    let selectedAccount = null;

    // Priority 1: Exact Match (Service + Direction)
    // Use ShippingDirection?.ID and ShippingServiceType?.ID from model
    selectedAccount = carrierAccounts.find(a =>
      a.ShippingDirection?.ID === currentDirectionId && a.ShippingServiceType?.ID === currentServiceTypeId
    );

    // Priority 2: Partial Match (Service only)
    if (!selectedAccount) {
      selectedAccount = carrierAccounts.find(a =>
        a.ShippingServiceType?.ID === currentServiceTypeId && (!a.ShippingDirection || a.ShippingDirection?.ID === 0)
      );
    }

    // Priority 3: Partial Match (Direction only)
    if (!selectedAccount) {
      selectedAccount = carrierAccounts.find(a =>
        a.ShippingDirection?.ID === currentDirectionId && (!a.ShippingServiceType || a.ShippingServiceType?.ID === 0)
      );
    }

    // Priority 4: Entity Fallback (first available for this carrier)
    if (!selectedAccount) {
      selectedAccount = carrierAccounts[0];
    }

    // Mark the selected account
    if (selectedAccount) {
      selectedAccount.IsSelected = true;
    }
  }

  /**
   * Handle manual selection of a carrier account by user
   */
  SelectCarrierAccount(account: any) {
    const accounts = this.CurrentPartner?.ContractualConditions?.ShippingCompanyAccounts;
    if (!accounts) return;

    // Clear all selections
    accounts.forEach(a => a.IsSelected = false);

    // Select the chosen account
    account.IsSelected = true;

    // Mark as manual selection to prevent algorithm override
    this.ManualCarrierAccountSelection = true;

    // Close dropdown
    this.showCarrierAccountDropdown = false;
  }

  /**
   * Get the currently selected carrier account for display
   */
  GetSelectedCarrierAccount(): any {
    const accounts = this.CurrentPartner?.ContractualConditions?.ShippingCompanyAccounts;
    if (!accounts) return null;
    return accounts.find(a => a.IsSelected === true);
  }

  /**
   * Get carrier accounts filtered for the currently selected shipping company and current company
   */
  GetFilteredCarrierAccounts(): any[] {
    const accounts = this.CurrentPartner?.ContractualConditions?.ShippingCompanyAccounts;
    if (!accounts) return [];
    const currentCarrierId = this.ShippingDetails?.ShippingCompany?.ID;
    const currentCompanyId = this.parent?.Company?.ID;
    // Filter by carrier AND (company matches OR no company binding)
    return accounts.filter(a =>
      a.FKShippingCompanyID === currentCarrierId &&
      (a.FKCompanyID === currentCompanyId || !a.FKCompanyID)
    );
  }

  /**
   * Format carrier account display text showing non-empty values in order:
   * [PartnerName] [CompanyName] [ShippingCompanyName] [ShippingDirection] [ShippingServiceType]
   */
  FormatCarrierAccountDisplay(account: any): string {
    if (!account) return '';

    const parts: string[] = [];

    if (account.PartnerName?.trim()) {
      parts.push(account.PartnerName.trim());
    }
    if (account.CompanyName?.trim()) {
      parts.push(account.CompanyName.trim());
    }
    if (account.ShippingCompanyName?.trim()) {
      parts.push(account.ShippingCompanyName.trim());
    }
    if (account.ShippingDirection?.Name?.trim()) {
      parts.push(account.ShippingDirection.Name.trim());
    }
    if (account.ShippingServiceType?.Name?.trim()) {
      parts.push(account.ShippingServiceType.Name.trim());
    }

    return parts.join(' | ');
  }

  AddNewBox(ShippingDetailsID:number){
    var box = {
      ID:0,
      ParentShippingDetailsID:ShippingDetailsID,
      Length:10,
      Width:10,
      Height:10,
      Weight:1,
      TrackingLabel:null,
      IsPallet:false,
      UIID:this.parent.newGuid(),
    };
  
    this.ShippingDetails.Boxes.push(box);
  }

  AddNewBoxWithDimentions(ShippingDetailsID:number, Length:number, Width:number, Height:number, Weight:number, boxID:number){
    var box = {
      ID:boxID,
      ParentShippingDetailsID:ShippingDetailsID,
      Length:Length,
      Width:Width,
      Height:Height,
      Weight:Weight,
      TrackingLabel:null,
      IsPallet:false,
      UIID:this.parent.newGuid(),
    };
  
    this.ShippingDetails.Boxes.push(box);
  }

  DeleteBox(box:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BoxID:box.ID
    };
  
    this.parent.loading = true;
  
    this.service.DeleteInvoiceBox(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingDetails.Boxes = this.ShippingDetails.Boxes.filter(item => item.UIID != box.UIID);
      }
  
      this.parent.loading = false;
    });
  }

  MultiplyBox(box:any, index:number){
    var factor = parseInt(box.MultiplyFactor);
    if(!factor || factor < 2 || factor > 10){
      return;
    }

    var newBoxes = [];
    for(var i = 0; i < factor - 1; i++){
      newBoxes.push({
        ID:0,
        ParentShippingDetailsID:box.ParentShippingDetailsID,
        Length:box.Length,
        Width:box.Width,
        Height:box.Height,
        Weight:box.Weight,
        TrackingLabel:null,
        IsPallet:box.IsPallet,
        UIID:this.parent.newGuid(),
        MultiplyFactor:null
      });
    }

    this.ShippingDetails.Boxes.splice(index + 1, 0, ...newBoxes);
    box.MultiplyFactor = null;
  }


  SimulateShippingCost(){

    this.DetermineSenderReceiver();

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:this.ShippingDetails
    };
  
    this.parent.loading = true;
  
    this.managementService.SimulateShippingCost(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.ShippingLabelErrorMessage = response["Message"];
        this.ShowShippingLabelError = true;
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];
      }

      this.parent.loading = false;
    });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  AddUpdateShippingAddress(address:any){

    if(address.ID == 0){
      address.IsSelected = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:address,
      PartnerID:this.CurrentPartner.ID
    };
  
    this.parent.loading = true;
  
    this.service.AddUpdateShippingAddress(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.RightOriginal = JSON.parse(JSON.stringify(response["ShippingAddress"]));
        this.Right = response["ShippingAddress"];
        this.updateRightChanged();
      }
  
      this.parent.loading = false;
    });
  }

  RequestPickup(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:this.ShippingDetails
    };
  
    this.parent.loading = true;
  
    this.managementService.RequestPickup(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  }

  CreateShippingLabel(withPickup:boolean){

    this.CreateShippingLabelSettings.EmailMessage = this.EmailMessage;
    this.CreateShippingLabelSettings.PartnerAgents = this.CurrentPartner?.PartnerAgents;

    if(this.ShippingDetails?.Partner?.PartnerAgents != null)
    {
      this.ShippingDetails.Partner.PartnerAgents = this.CurrentPartner?.PartnerAgents;
    }

    // Attach the selected carrier account to ShippingDetails for third-party billing
    const selectedAccount = this.GetSelectedCarrierAccount();
    if (selectedAccount) {
      this.ShippingDetails.CarrierAccount = selectedAccount;
    }

    this.DetermineSenderReceiver();

    // Document Connection Pre-check: check for unlinked documents before generating label
    if(this.CurrentPartner?.ID && this.ShippingDetails?.ShippingDirection?.ID){
      this.PendingWithPickup = withPickup;
      this.parent.loading = true;

      var precheckRequest = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:this.CurrentPartner.ID,
        DirectionID:this.ShippingDetails.ShippingDirection.ID
      };

      this.managementService.GetUnlinkedDocumentsForPartner(precheckRequest).subscribe(response => {
        this.parent.loading = false;

        if(response["Status"] == 1 && response["UnlinkedDocuments"]?.length > 0){
          this.UnlinkedDocuments = response["UnlinkedDocuments"];
          this.SelectedUnlinkedDocument = null;
          this.ShowDocumentPrecheck = true;
        }
        else{
          // No unlinked documents found, proceed directly
          this.ExecuteCreateShippingLabel(withPickup, null);
        }
      });
    }
    else{
      this.ExecuteCreateShippingLabel(withPickup, null);
    }
  }

  SelectUnlinkedDocument(doc:any){
    this.SelectedUnlinkedDocument = doc;
  }

  ConfirmDocumentPrecheck(){
    this.ShowDocumentPrecheck = false;
    this.ExecuteCreateShippingLabel(this.PendingWithPickup, this.SelectedUnlinkedDocument?.ID || null);
  }

  SkipDocumentPrecheck(){
    this.ShowDocumentPrecheck = false;
    this.ExecuteCreateShippingLabel(this.PendingWithPickup, null);
  }

  ExecuteCreateShippingLabel(withPickup:boolean, selectedDocumentID:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:this.ShippingDetails,
      WithPickup:withPickup,
      CreateShippingLabelSettings:this.CreateShippingLabelSettings,
      SelectedDocumentID:selectedDocumentID
    };

    this.parent.loading = true;

    this.managementService.CreateShippingLabel(request).subscribe(response => {

      if(response["Status"] == -1){
        this.ShippingLabelErrorMessage = response["Message"];
        this.ShowShippingLabelError = true;
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];
        this.TaskCompleted = true;

        if(this.CreateShippingLabelSettings.DownloadType != null && this.ShippingDetails.Documents?.length > 0){
          for(var i=0; i < this.ShippingDetails.Documents.length; i++){

            var Document = JSON.parse(JSON.stringify(this.ShippingDetails.Documents[i]));

            if(this.CreateShippingLabelSettings.DownloadType.ID == 1){
              this.parent.download(Document.Name, Document.PDFStream);
            }
            else if(this.CreateShippingLabelSettings.DownloadType.ID == 2){
              this.parent.printPage(Document.Name , Document.PDFStream, Document.ID);
            }

          }
        }
      }

      this.parent.loading = false;
    });
  }

  ReDownloadDocuments(DownloadTypeID:number){
    
    for(var i=0; i < this.ShippingDetails.Documents.length; i++){
            
      var Document = JSON.parse(JSON.stringify(this.ShippingDetails.Documents[i]));

      if(DownloadTypeID == 1){
        this.parent.download(Document.Name, Document.PDFStream);
      }
      else if(DownloadTypeID == 2){
        this.parent.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

    }
  }

  SelectDownloadType(type:any){
    this.CreateShippingLabelSettings.DownloadType = JSON.parse(JSON.stringify(type));
  }

  SMTPConfigs:any[];
  SMTPEmails:any[];
  CurrenctSMTP:any;
  CurrentSMTPEmail: {[k: string]: any} = {};
  EmailMessage: {[k: string]: any} = {};
  GeneralDocType:any;
  EmailDocumentID:any;

  GetCompanySMTPConfigs(){
    var request = {
      User:this.parent.User,
      Language:this.CurrentPartner?.BillingAddress?.Country?.Language?.Name,
      UILanguage:this.parent.getLanguage(),
      CompanyID:this.parent.Company.ID
    };
  
    this.parent.loading = true;
  
    this.service.GetCompanySMTPConfigs(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SMTPConfigs = response["SMTPConfigs"];
  
        if(this.SMTPConfigs.length > 0){
          this.CurrenctSMTP = this.SMTPConfigs[0];
          this.GetCompanySMTPEmails(this.CurrenctSMTP.ID);
        }
      }
     
      this.parent.loading = false;
    });
  }
  
  GetCompanySMTPEmails(SMTPID:any){
    var request = {
      User:this.parent.User,
      Language:this.CurrentPartner.BillingAddress.Country.Language.Name,
      UILanguage:this.parent.getLanguage(),
      SMTPID:SMTPID
    };
  
    this.parent.loading = true;
  
    this.service.GetCompanySMTPEmails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SMTPEmails = response["Emails"];
  
        if(this.SMTPEmails.length > 0){
          this.CurrentSMTPEmail = this.SMTPEmails?.filter(x => x.Email == this.parent.User.Email)[0];
  
          if(this.CurrentSMTPEmail == null){
            this.CurrentSMTPEmail = this.SMTPEmails[0];
          }
  
          this.EmailMessage.GeneralDocType = this.GeneralDocType;
          this.EmailMessage.ToEmail = this.CurrentPartner.ContactInfo.Email;
          this.EmailMessage.EmailModel = {};
          this.EmailMessage.EmailModel = this.CurrentSMTPEmail;
          this.EmailMessage.DocumentID = this.parent.newGuid();
          this.EmailMessage.SMTPServer = this.CurrenctSMTP.SMTPServer;
          this.EmailMessage.Port = this.CurrenctSMTP.Port;
  
          this.GenerateManagementEmailSubject();
        }
      }
     
      this.parent.loading = false;
    });
  }

  GenerateManagementEmailSubject(){
    var request = {
      User:this.parent.User,
      Language:this.CurrentPartner.BillingAddress.Country.Language.Name,
      Type:this.ShippingDetails?.ShippingDirection?.ID ?? -1
    };
  
    this.parent.loading = true;
  
    this.service.GenerateManagementEmailSubject(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.EmailMessage.EmailModel.Subject = response["Subject"];
        this.EmailMessage.EmailModel.DefaultMessage = response["Body"];

        this.CurrentPartner.PartnerAgents.forEach(element => {
          element.IsSelected = true;
        });

        // Show email settings panel now that all data is ready
        this.ShowEmailSettings = true;
      }

      this.parent.loading = false;
    });
  }

  ShowEmailSettings:boolean;

  ViewEmailSettings(){

    // If toggling OFF, just close settings
    if(this.CreateShippingLabelSettings.SendEmail == false){
      this.ShowEmailSettings = false;
      return;
    }

    // If SMTP data not loaded yet, load it first (ShowEmailSettings will be set after async load completes)
    if(this.SMTPEmails == null || this.SMTPEmails?.length == 0){
        this.GetCompanySMTPConfigs();
        this.GetSetPartnerAgents();
    }
    else {
        this.ShowEmailSettings = true;
    }
  }

  CloseEmailSettings(){
    this.ShowEmailSettings = false;
  }

  DetermineSenderReceiver(){
    if(this.ShippingDetails.ShippingDirection.ID == 1){
      this.ShippingDetails.Sender = JSON.parse(JSON.stringify(this.Left));
      this.ShippingDetails.Receiver = JSON.parse(JSON.stringify(this.Right));
    }
    else if(this.ShippingDetails.ShippingDirection.ID == -1){
      this.ShippingDetails.Sender = JSON.parse(JSON.stringify(this.Right));
      this.ShippingDetails.Receiver = JSON.parse(JSON.stringify(this.Left));
    }
  }

  deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return true;
    }
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
      return false;
    }
    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  updateRightChanged() {
    this.RightChanged = !this.deepEqual(this.Right, this.RightOriginal);
  }

  ShowAllAddresses:boolean = false;
  LoadingShippingAddressSelection:boolean = false;
  SelectedAddressLine:string;

  // Company Shipping Addresses
  CompanyShippingAddresses:any[] = [];
  ShowAllCompanyAddresses:boolean = false;
  SelectedCompanyAddressLine:string;

  GetCompanyShippingAddresses(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.parent.Company.ID
    };

    this.service.GetCompanyShippingAddresses(request).subscribe(response => {
      if(response["Status"] == 1){
        this.CompanyShippingAddresses = response["ShippingAddresses"] || [];
        // Default to first address
        if(this.CompanyShippingAddresses.length > 0){
          this.CompanyShippingAddresses[0].IsSelected = true;
          this.SelectCompanyShippingAddress(this.CompanyShippingAddresses[0]);
        }
      }
    });
  }

  OpenCloseShowAllCompanyAddresses(){
    this.ShowAllCompanyAddresses = !this.ShowAllCompanyAddresses;
  }

  SelectCompanyShippingAddress(address:any){
    this.CompanyShippingAddresses.forEach(a => a.IsSelected = false);
    address.IsSelected = true;
    this.SelectedCompanyAddressLine = (address.Country?.ShortName || '') + ' - ' + (address.City || '') + ', ' + (address.ContactPerson || '');

    // Apply selected address to Left (company side)
    this.Left.ContactCompany = address.ContactCompany || this.Left.ContactCompany;
    this.Left.ContactPerson = address.ContactPerson || '';
    this.Left.VATNumber = address.VATNumber || this.Left.VATNumber;
    if(address.Country) {
      this.Left.Country = JSON.parse(JSON.stringify(address.Country));
      this.PatchFlagURL(this.Left.Country);
    }
    this.Left.State = address.State || '';
    this.Left.City = address.City || '';
    this.Left.AddressLine = address.AddressLine || '';
    this.Left.ZipCode = address.ZipCode || '';
    this.Left.Email = address.Email || this.Left.Email;
    this.Left.Phone = address.Phone || this.Left.Phone;

    this.LeftOriginal = JSON.parse(JSON.stringify(this.Left));
    this.ShowAllCompanyAddresses = false;
  }

  GenerateCompanyAddressLine(){
    if(this.CompanyShippingAddresses?.length > 0){
      for(var i=0; i< this.CompanyShippingAddresses.length; i++){
        if(this.CompanyShippingAddresses[i].IsSelected == true){
          this.SelectedCompanyAddressLine = (this.CompanyShippingAddresses[i].Country?.ShortName || '') + ' - ' + (this.CompanyShippingAddresses[i].City || '') + ', ' + (this.CompanyShippingAddresses[i].ContactPerson || '');
          break;
        }
      }
    }
  }

  OpenCloseShowAllAddresses(){
    this.ShowAllAddresses = !this.ShowAllAddresses;
  }

  SelectShippingAddressFromUI(preferredAddress:any){

    if(preferredAddress != null && preferredAddress.ID != null){
      this.CurrentPartner.ShippingAddresses.forEach(element => {
        element.IsSelected = false;

        if(element.ID == preferredAddress.ID){
          element.IsSelected = true;
        }
      });

      this.ShippingAddresses.forEach(element => {
        element.IsSelected = false;

        if(element.ID == preferredAddress.ID){
          element.IsSelected = true;
        }
      });
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:preferredAddress,
      PartnerID:this.CurrentPartner?.ID
    };
  
    this.LoadingShippingAddressSelection = true;
  
    this.managementService.SelectShippingAddressFromUI(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var address = response["ShippingAddress"];
        this.Right = JSON.parse(JSON.stringify(address));
        this.RightOriginal = JSON.parse(JSON.stringify(address));
        this.updateRightChanged();
        this.ShowAllAddresses = false;
      }
  
      this.LoadingShippingAddressSelection = false;
    });
  }

  GenerateMainAddressLine(){
    if(this.ShippingAddresses != null && this.ShippingAddresses?.length > 0){
      for(var i=0; i< this.ShippingAddresses?.length; i++){
        if(this.ShippingAddresses[i].IsSelected == true){
          this.SelectedAddressLine = this.ShippingAddresses[i].Country?.ShortName +" - "+ this.ShippingAddresses[i].City +", "+ this.ShippingAddresses[i].ContactPerson;
          break;
        }
      }
    }
  }

  ShowAddNewPartner:boolean = false;

  ShowAddNewPartnerContainer(){

    this.NewPartnerAddress = null;
    this.NewPartnerAddress = {};
    this.NewPartnerAddress.ID = 0;
    this.NewPartnerAddress.ContactCompany = this.Filter.SearchTerm;
    this.NewPartnerAddress.ContactPerson = "";
    this.NewPartnerAddress.VATNumber = "";

    this.NewPartnerAddress.Country = {};
    this.NewPartnerAddress.Country.ID = 0;

    this.NewPartnerAddress.State = "";
    this.NewPartnerAddress.City = "";
    this.NewPartnerAddress.AddressLine = "";
    this.NewPartnerAddress.ZipCode = "";
    this.NewPartnerAddress.Email = "";
    this.NewPartnerAddress.Phone = "";

    this.ShowAddNewPartner = true;
  }

  AddNewPartnerValid:boolean = false;
  LoadingAddNewPartnerFromShippingAddress:boolean = false;

  ProofNewPartnerAddress(){
    if(this.NewPartnerAddress.ContactCompany.length > 0){
      if(this.NewPartnerAddress.ContactPerson.length > 0){
        if(this.NewPartnerAddress.Country.ID > 0){
          if(this.NewPartnerAddress.State.length > 0){
            if(this.NewPartnerAddress.City.length > 0){
              if(this.NewPartnerAddress.AddressLine.length > 0){
                if(this.NewPartnerAddress.ZipCode.length > 0){
                  if(this.NewPartnerAddress.Email.length > 0){
                    if(this.NewPartnerAddress.Phone.length > 0){
                      this.AddNewPartnerValid = true;
                    }
                    else{
                      this.AddNewPartnerValid = false;
                    }
                  }
                  else{
                    this.AddNewPartnerValid = false;
                  }
                }
                else{
                  this.AddNewPartnerValid = false;
                }
              }
              else{
                this.AddNewPartnerValid = false;
              }
            }
            else{
              this.AddNewPartnerValid = false;
            }
          }
          else{
            this.AddNewPartnerValid = false;
          }
        }
        else{
          this.AddNewPartnerValid = false;
        }
      }
      else{
        this.AddNewPartnerValid = false;
      }
    }
    else{
      this.AddNewPartnerValid = false;
    }
  }

  AddNewPartnerFromShippingAddress(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:this.NewPartnerAddress
    };
  
    this.LoadingAddNewPartnerFromShippingAddress = true;
  
    this.service.AddNewPartnerFromShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowAddNewPartner = false;
        this.CurrentPartner = response["Partner"];
        this.Right = response["ShippingAddress"];
        this.Filter.SearchTerm = this.Right?.ContactCompany;
        this.showBottom = true;
      }
     
      this.SelectPartner(this.CurrentPartner);
      this.LoadingAddNewPartnerFromShippingAddress = false;
    });
  }

  ShowCompareShippingCostsContainer:boolean;
  AnyGeneralShippingServiceTypeSelected:boolean = false;
  ComparingShippingDetails:any[];

  OpenCompareShippingCosts(){
    this.ShowCompareShippingCostsContainer = true;
    this.ComparationCompleted = false;
    this.ComparingShippingDetails = [];

    for(var i=0; i < this.ShippingCompanies.length; i++){
      var d = JSON.parse(JSON.stringify(this.ShippingDetails));
      d.ShippingCompany = JSON.parse(JSON.stringify(this.ShippingCompanies[i]));

      if(this.ShippingDetails.ShippingDirection.ID == 1){
        d.Sender = JSON.parse(JSON.stringify(this.Left));
        d.Receiver = JSON.parse(JSON.stringify(this.Right));
      }
      else if(this.ShippingDetails.ShippingDirection.ID == -1){
        d.Sender = JSON.parse(JSON.stringify(this.Right));
        d.Receiver = JSON.parse(JSON.stringify(this.Left));
      }

      this.ComparingShippingDetails.push(d);
    }

    this.GeneralShippingServiceTypes.forEach(element => {
      element.IsSelected = false;
    });

    if(this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes?.length > 0 && this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes.some(x => x.IsSelected == true)){
      this.SelectGeneralShippingServiceType(this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes.filter(x => x.IsSelected == true)[0]);
    }
    else{
      this.SelectGeneralShippingServiceType(this.GeneralShippingServiceTypes[1]);
    }

    this.AnyGeneralShippingServiceTypeSelected = false;
  }

  SelectGeneralShippingServiceType(s:any){
    this.GeneralShippingServiceTypes.forEach(element => {
      if(element.ID == s.ID){
        element.IsSelected = true;
        this.AnyGeneralShippingServiceTypeSelected = true;
      }
      else{
        element.IsSelected = false;
      }
    });

    this.ComparingShippingDetails.forEach(element => {
      if(element?.ShippingCompany?.ShippingServiceTypes?.length > 0){
        element.ShippingCompany.ShippingServiceTypes.forEach(type => {
          if(type.ID == s.ID){
            type.IsSelected = true;
          }
          else{
            type.IsSelected = false;
          }
        });
      }
    });
  }

  ComparationCompleted:boolean = false;

  CompareShippingCosts(){
    this.CreateShippingLabelSettings.EmailMessage = this.EmailMessage;
    this.CreateShippingLabelSettings.PartnerAgents = this.CurrentPartner?.PartnerAgents;

    if(this.ShippingDetails?.Partner?.PartnerAgents != null)
    {
      this.ShippingDetails.Partner.PartnerAgents = this.CurrentPartner?.PartnerAgents;
    }

    this.DetermineSenderReceiver();

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:this.ShippingDetails,
      CreateShippingLabelSettings:this.CreateShippingLabelSettings,
      ComparingShippingDetails:this.ComparingShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.managementService.CompareShippingCosts(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ComparingShippingDetails = response["ShippingDetails"];
        this.ComparationCompleted = true;
      }
     
      this.parent.loading = false;
    });
  }

  SelectComparingShippingDetailsShippingCompany(s:any){
    this.ComparingShippingDetails.forEach(element => {
      if (element.ShippingCompany.ID === s.ID) {
        element.ShippingCompany.IsSelected = true;
      } else {
        element.ShippingCompany.IsSelected = false;
      }
    });
  }

  GetSetPartnerAgents(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.CurrentPartner
    };
  
    this.parent.loading = true;
  
    this.service.GetSetPartnerAgents(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentPartner.PartnerAgents = response["PartnerAgents"];
        this.ShowEmailSettings = true;
      }
     
      this.parent.loading = false;
    });
  }

  AcceptComparedShippingCompany(){
    this.ComparingShippingDetails.forEach(element => {
      if(element.ShippingCompany.IsSelected == true){
        this.SelectShippingCompany(element.ShippingCompany);
        this.ShowCompareShippingCostsContainer = false;
      }
    });
  }

  HistoricalShipments:any[];
  HistoryBoxes:any[];
  HistoryLoading:boolean;
  ShowHistory:boolean = false;

  OpenHistoricalShipments(){
    if(this.HistoryBoxes == null){
      this.GetShippingDimentionsHistory();
    }
  }

  CloseHistoricalShipments(){
    this.HistoricalShipments = null;
    this.HistoryBoxes = null;
    this.ShowHistory = false;
  }

  DisconnectTrackingFromHistoricalShipment(){
      this.ConnectedShippingToHistoryTracking = false;

      this.ShippingDetails.ID = 0;
      this.ShippingDetails.ParentDetailsID = null;
      this.ShippingDetails.Boxes.forEach(box => {
        box.ParentShippingDetailsID = null;
        box.ID = 0;
      });

      this.InitializeHistoryPlaceholder();
  }

  GetShippingDimentionsHistory(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.CurrentPartner.ID,
      DirectionID:this.ShippingDetails?.ShippingDirection?.ID
    };
  
    this.HistoryLoading = true;
  
    this.managementService.GetShippingDimentionsHistory(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.HistoricalShipments = response["GroupedHistoricalShipments"];
        this.HistoryBoxes = response["HistoryBoxes"];
        this.ShowHistory = true;
      }

      this.HistoryLoading = false;
    });
  }

  AskForShipmentConnection:boolean = false;
  CurrentHistoricalShipment:any;

  ShowShippingLabelError:boolean = false;
  ShippingLabelErrorMessage:string = '';

  AskForDocumentConnection(shipment:any){
    if(shipment.TrackingLabel?.length < 5){
      this.CurrentHistoricalShipment = JSON.parse(JSON.stringify(shipment));
      this.AskForShipmentConnection = true;
    }
    else{
      this.SelectHistoryTracking(shipment, false);
    }
  }

  ConnectedShippingToHistoryTracking:boolean = false;

  SelectHistoryTracking(shipment:any, connectShipmentToTracking:boolean){
    this.ShippingDetails.Boxes = null;
    this.ShippingDetails.Boxes = [];
    this.ShippingDetails.Boxes.length = 0;

    if(connectShipmentToTracking == false){
      shipment.Boxes.forEach(box => {
        this.AddNewBoxWithDimentions(null, box.Length, box.Width, box.Height, box.Weight, 0);
      });
    }
    else{
      shipment.Boxes.forEach(box => {
        this.AddNewBoxWithDimentions(shipment.ID, box.Length, box.Width, box.Height, box.Weight, box.ID);
      });

      this.ShippingDetails.ID = shipment.ID;
      this.ShippingDetails.ParentDetailsID = shipment.ParentDetailsID;
      this.HistoryPlaceHolder = shipment.TrackingLabel +" "+ shipment.EventRegisterUI;
      this.ConnectedShippingToHistoryTracking = true;
      
      var lang = this.parent.getLanguage();
      
      if(lang == "ro"){
        this.parent.openSnackBar("Transporturile sunt conectate!", "OK", "light-info-snackbar");
      }
      else if(lang == "en"){
        this.parent.openSnackBar("Shipments are connected!", "OK", "light-info-snackbar");
      }
    }

    this.CloseHistoricalShipments();
  }

  InitializeHistoryPlaceholder(){
    var lang = this.parent.getLanguage();
      
      if(lang == "ro"){
        this.HistoryPlaceHolder = "Alege din istoric transporturi";
      }
      else if(lang == "en"){
        this.HistoryPlaceHolder = "Choose from transportation history";
      }
  }

  ShowPriceDetails(){
    this.ShippingDetails.ShowDetailedShippingPrice = !this.ShippingDetails.ShowDetailedShippingPrice;

  }

  // Copy to clipboard functionality
  CopiedToClipboard: boolean = false;

  CopyTransportInfoToClipboard(){
    let textToCopy = '';

    if(this.ShippingDetails?.ShippingDetailsText){
      textToCopy += this.ShippingDetails.ShippingDetailsText + '\n';
    }

    if(this.ShippingDetails?.TrackingLabel?.length > 0){
      textToCopy += this.translate.instant('TrackingLabel') + ': ' + this.ShippingDetails.TrackingLabel + '\n';
    }

    if(this.ShippingDetails?.PickupInformation?.CarrierPickupNumber?.length > 0){
      textToCopy += this.translate.instant('PickupNumber') + ': ' + this.ShippingDetails.PickupInformation.CarrierPickupNumber + '\n';
    }

    if(this.ShippingDetails?.PickupInformation?.PickupDateUI?.length > 0){
      textToCopy += this.translate.instant('PickupDate') + ': ' + this.ShippingDetails.PickupInformation.PickupDateUI + '\n';
    }

    if(this.ShippingDetails?.PickupInformation?.PickupEarliestUI?.length > 0){
      textToCopy += this.translate.instant('PickupEarliest') + ': ' + this.ShippingDetails.PickupInformation.PickupEarliestUI + '\n';
    }

    if(this.ShippingDetails?.PickupInformation?.PickupLatestUI?.length > 0){
      textToCopy += this.translate.instant('PickupLatest') + ': ' + this.ShippingDetails.PickupInformation.PickupLatestUI + '\n';
    }

    if(this.ShippingDetails?.ShippingServiceType?.Name?.length > 0){
      textToCopy += this.translate.instant('ShippingServiceType') + ': ' + this.ShippingDetails.ShippingServiceType.Name + '\n';
    }

    if(this.ShippingDetails?.ShippingWay?.Name?.length > 0){
      textToCopy += this.translate.instant('ShippingWay') + ': ' + this.ShippingDetails.ShippingWay.Name + '\n';
    }

    // Copy to clipboard
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.CopiedToClipboard = true;

      var lang = this.parent.getLanguage();
      if(lang == "ro"){
        this.parent.openSnackBar("Copiat în clipboard!", "OK", "light-info-snackbar");
      }
      else if(lang == "en"){
        this.parent.openSnackBar("Copied to clipboard!", "OK", "light-info-snackbar");
      }

      // Reset the copied state after 2 seconds
      setTimeout(() => {
        this.CopiedToClipboard = false;
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);

      var lang = this.parent.getLanguage();
      if(lang == "ro"){
        this.parent.openSnackBar("Eroare la copiere!", "OK", "alert-danger-snackbar");
      }
      else if(lang == "en"){
        this.parent.openSnackBar("Failed to copy!", "OK", "alert-danger-snackbar");
      }
    });
  }

  // Patch flaglog.com URLs to flagcdn.com (flaglog.com blocks hotlinking)
  PatchFlagURL(country: any): void {
    if (country?.FlagURL && country.FlagURL.includes('flaglog.com')) {
      // Extract country code from URL like: https://flaglog.com/codes/standardized-rectangle-120px/RO.png
      var match = country.FlagURL.match(/\/([A-Z]{2})\.png$/i);
      if (match) {
        country.FlagURL = 'https://flagcdn.com/w160/' + match[1].toLowerCase() + '.png';
      }
    }
  }

  PatchFlagURLs(countries: any[]): void {
    if (countries?.length > 0) {
      countries.forEach(c => this.PatchFlagURL(c));
    }
  }
}
